import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "file-info" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = {
  abbr: "details about file",
  class: "info__heading"
}
const _hoisted_4 = { class: "info" }
const _hoisted_5 = {
  abbr: "file information, e.g type, size etc",
  class: "info__heading"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { key: 6 }
const _hoisted_13 = { key: 7 }
const _hoisted_14 = { key: 8 }
const _hoisted_15 = { key: 9 }

import { toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { DirectoryItem } from './types'
import DirectoryItemField from './DirectoryItemField.vue'

type Props = {
  directoryItem: DirectoryItem<'file'>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FileMetaInfo',
  props: {
    directoryItem: { default: undefined }
  },
  setup(__props: any) {

const props = __props
const { directoryItem } = toRefs(props)
const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("table", null, [
        _createElementVNode("th", _hoisted_3, _toDisplayString(_unref(t)('general__text__details')), 1),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__uploaded')), 1),
          _createElementVNode("td", null, [
            _createVNode(DirectoryItemField, {
              item: _unref(directoryItem),
              field: "uploadDate",
              options: { type: 'tiny', weight: 'bold' }
            }, null, 8, ["item"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__uploaded-by')), 1),
          _createElementVNode("td", null, [
            _createVNode(DirectoryItemField, {
              item: _unref(directoryItem),
              field: "uploadedBy",
              options: { type: 'tiny', weight: 'bold' }
            }, null, 8, ["item"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__placement')), 1),
          _createElementVNode("td", null, [
            _createVNode(DirectoryItemField, {
              item: _unref(directoryItem),
              field: "entityConnection"
            }, null, 8, ["item"])
          ])
        ])
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("table", null, [
        _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)('general__data__file-information')), 1),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__file-type')), 1),
          _createElementVNode("td", null, [
            _createVNode(DirectoryItemField, {
              item: _unref(directoryItem),
              field: "type",
              options: { type: 'tiny', weight: 'bold' }
            }, null, 8, ["item"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__size')), 1),
          _createElementVNode("td", null, [
            _createVNode(DirectoryItemField, {
              item: _unref(directoryItem),
              field: "fileSize"
            }, null, 8, ["item"])
          ])
        ]),
        (_unref(directoryItem).metadata?.lastModified)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__last-modified-date')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "lastModified",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.lastAuthor)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
              _createElementVNode("td", null, _toDisplayString(`${_unref(t)('general__text__last-modified')} ${_unref(t)('general__text__by').toLowerCase()}`), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "lastAuthor",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.createdDate)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__created-date')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "createdDate",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.creator)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
              _createElementVNode("td", null, _toDisplayString(`${_unref(t)('general__text__created')} ${_unref(t)('general__text__by').toLowerCase()}`), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "creator",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.nrOfPages)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__pages-number-of')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "nrOfPages",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.lastModified)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__last-modified-date')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "lastModified",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.width)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__width')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "width",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.length)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__data__length')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "length",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(directoryItem).metadata?.height)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__height')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "height",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true),
        (
            (_unref(directoryItem).metadata?.xresolution || _unref(directoryItem).metadata?.xResolution) &&
            (_unref(directoryItem).metadata?.yResolution || _unref(directoryItem).metadata?.yresolution)
          )
          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)('general__text__dimensions')), 1),
              _createElementVNode("td", null, [
                _createVNode(DirectoryItemField, {
                  item: _unref(directoryItem),
                  field: "resolution",
                  options: { type: 'tiny', weight: 'bold' }
                }, null, 8, ["item"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})